import PageHeader from "../../components/PageHeader";
import Form from "../../components/Form";
import ContactInfo from "../../components/ContactInfo";

/**
 * Represents the Contact page component.
 * Displays a contact form and contact information side by side.
 *
 * @component
 */

const Contact = () => {
  return (
    <main className="contact container">
      <PageHeader title="Contact" description="Get in touch" />
      <p className="pageLead">
        Building a mobile app, a web platform or need an extra senior engineer on your team? Tell me what you're
        working on — I'll get back to you quickly with next steps.
      </p>

      <div className="contactWrap container">
        <div className="row">
          <div className="col-12 col-lg-6">
            <Form />
          </div>
          <div className="col-12 col-lg-6">
            <ContactInfo />
          </div>
        </div>
      </div>
    </main>
  );
};

export default Contact;
